import { FloatingTooltip } from '@/components/common/Floating'
import { LinkOutbound } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { useMisc } from '@/components/providers/MiscProvider'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'
import { formatPrice } from '@/utils/formatUtil'

import styles from '../PriceSource.module.scss'

type Props = {
  ariaLabel: string
  className?: string
  href: string
  icon?: IconType
  price?: number
}

export const PriceSourceTCGPlayer = ({ ariaLabel, className, href, icon, price }: Props) => {
  const { tcgplayerSale } = useMisc()
  const { end, percent = 0 } = tcgplayerSale || {}

  const priceDisplay = formatPrice(((100 - percent) / 100) * (price || 0))

  const title = `${ariaLabel} (${priceDisplay})`

  const linkElement = (
    <LinkOutbound
      aria-label={title}
      className={cn(className, { isSale: percent > 0, styles })}
      href={href}
      title={title}
      utm={false}
    >
      <IconWithLabel iconBefore={icon} iconBeforeMargin='sm'>
        {priceDisplay}
      </IconWithLabel>
    </LinkOutbound>
  )

  if (percent > 0) {
    return (
      <FloatingTooltip
        content={
          <p>
            On Sale Until <strong>{end}</strong>
          </p>
        }
        placement='top'
        styled
      >
        {linkElement}
      </FloatingTooltip>
    )
  }

  return linkElement
}
